var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 18h3.4l7.825-8.049a1 1 0 0 0-.01-1.404l-4.252-4.252a1 1 0 0 0-1.414 0L12 6.843l-8.128 8.129a1 1 0 0 0 .003 1.417L5.501 18zm6.256-12.998L13.06 7.197l4.283 4.283 2.164-2.226zm1.391 7.195-4.293-4.293-7.775 7.775 1.333 1.32H9l2.978.001zM3.5 19a.5.5 0 1 0 0 1h17a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgTextEditEraser = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextEditEraser);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05IDE3Ljk5OTRMMTIuNCAxOC4wMDAxTDIwLjIyNTQgOS45NTEzMkMyMC42MDY1IDkuNTU5MjcgMjAuNjAyMSA4LjkzMzc3IDIwLjIxNTUgOC41NDcxMkwxNS45NjMgNC4yOTQ2QzE1LjU3MjQgMy45MDQwOCAxNC45MzkzIDMuOTA0MDggMTQuNTQ4OCA0LjI5NDZMMTIgNi44NDMzMUwzLjg3MTcgMTQuOTcxN0MzLjQ3OTg2IDE1LjM2MzUgMy40ODEzOCAxNS45OTkzIDMuODc1MSAxNi4zODkyTDUuNTAwNzggMTcuOTk5NEg5Wk0xNS4yNTU5IDUuMDAxNzFMMTMuMDYwNyA3LjE5Njg3TDE3LjM0NDEgMTEuNDgwM0wxOS41MDg0IDkuMjU0MjNMMTUuMjU1OSA1LjAwMTcxWk0xNi42NDcgMTIuMTk3M0wxMi4zNTM2IDcuOTAzOTdMNC41Nzg4MSAxNS42Nzg4TDUuOTEyMTkgMTYuOTk5NEw5IDE2Ljk5OTRIOS4wMDAxOUwxMS45Nzc2IDE3TDE2LjY0NyAxMi4xOTczWk0zLjUgMTkuMDAwMUMzLjIyMzg2IDE5LjAwMDEgMyAxOS4yMjM5IDMgMTkuNTAwMUMzIDE5Ljc3NjIgMy4yMjM4NiAyMC4wMDAxIDMuNSAyMC4wMDAxSDIwLjVDMjAuNzc2MSAyMC4wMDAxIDIxIDE5Ljc3NjIgMjEgMTkuNTAwMUMyMSAxOS4yMjM5IDIwLjc3NjEgMTkuMDAwMSAyMC41IDE5LjAwMDFIMy41WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";